<template>
    <div class="ion-page">
        <ion-header>
            <ion-toolbar class="mobile-header-toolbar">
            <ion-buttons v-slot: start>
                <ion-back-button default-href="#" @click="navigatePreviousPage"></ion-back-button>
                <ion-title>Payment Details / Edit</ion-title>
            </ion-buttons>
            </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
        <ManageUserEdit />
        </ion-content>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import ManageUserEdit from "@/components/admin/ManageUserEdit.vue";
import { IonBackButton, IonButtons, IonContent, IonHeader, IonMenuButton, IonTitle, IonToolbar } from '@ionic/vue';

export default defineComponent({
    name:  'manageUserEdit',
    components: {
        ManageUserEdit, IonHeader, IonToolbar, IonButtons, IonMenuButton, IonBackButton, IonTitle, IonContent
    },
    data() {
        return {
            displayBackbutton: false
        }
    },
    async mounted() {
    },
    methods: {
        navigatePreviousPage() {
            this.$router.go(-1)
        }
    }
})
</script>